import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot from react-dom/client
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import store from "./store"; // Import the Redux store
import { ApolloProvider } from "@apollo/client"; // Import ApolloProvider for Apollo Client
import { client } from "./apolloClient"; // Import Apollo Client instance

// Get the root DOM element
const container = document.getElementById("root");

// Use createRoot instead of ReactDOM.render
const root = createRoot(container);

// Wrap the App component with both ApolloProvider (for GraphQL) and Provider (for Redux)
root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>
);

// Start measuring performance in your app, pass a function to log results (optional)
reportWebVitals();
